import Pidgin from '@lessonnine/pidgin.js'
import { isPrivateEnv, LOCALE } from 'src/dataLayer/env'

const importAll = (req) =>
  // eslint-disable-next-line unicorn/no-array-reduce -- we need to reduce the array to an object
  req.keys().reduce((acc, file) => {
    let locale = file.replace('./', '').replace('.json', '')
    if (locale === 'en-GB') locale = 'en_GB'

    return {
      ...acc,
      [locale]: req(file),
    }
  }, {})

const locales = importAll(require.context('src/viewLayer/assets/locales', false, /\.json$/))

const pidgin = new Pidgin({
  isICU: true,
  locales,
  onMissingKey: () => {
    // eslint-disable-next-line no-useless-return -- we need to return if the environment is private
    if (isPrivateEnv()) return
  },
})

const translations = () => {
  if (pidgin.locale !== LOCALE) {
    pidgin.configure({ locale: LOCALE })
  }
  return pidgin
}

const t = (...parameters) => translations().t(...parameters)

const namespaceT = (...parameters) => translations().namespace(...parameters)

export { namespaceT, t }
